import {i18next} from 'common/i18n';
import {NamedError} from 'common/report/queries/utils/named-error';

/** The error the server answers with when a sensitive change needs a fresh step-up reauth. */
export const REAUTH_REQUIRED_ERROR = `reauth_required`;

/**
 * Thrown by `fetchWithReauth` when the user cancels the reauth prompt. Callers skip their
 * error handling for it: nothing changed, by choice.
 */
export class ReauthDeclinedError extends NamedError {
  constructor() {
    super(REAUTH_REQUIRED_ERROR);
    // Literal so Sentry's name-based ignore filter survives bundler minification.
    this.name = `ReauthDeclinedError`;
  }
}

export function isReauthDeclined(err: unknown): err is ReauthDeclinedError {
  return err instanceof ReauthDeclinedError;
}

/**
 * `fetchWithReauth` prompts on `reauth_required` and retries once, so a caller only sees one
 * when the server still rejected the retry, e.g. because the org's allowed reauth methods
 * changed while the prompt was open.
 */
export function reauthRejectedMessage(): string {
  return i18next.t(`settings.org-settings.verify-identity.rejected`);
}
